module.exports = __webpack_public_path__ + "static/r35-d27a68e7d0e3e86f21776ca4375a2735.jpg";